import { useContext } from 'react';
import { ActivityAudioContext, UseAppSound } from '../providers/ActivityAudioProvider';

const useActivityAudio = (): UseAppSound => {
  const [state, dispatch] = useContext(ActivityAudioContext);

  return [state, dispatch];
};

export default useActivityAudio;
